import styled from 'styled-components';
import { Select } from 'antd';
import media from '../../../styles/media.style';
import { BLACK, TEXT_GRAY } from '../../../styles/variables.style';

const FONT_FAMILY = 'FuturaStd';
export const MainInner = styled.section`
  margin: 0 auto;
  max-width: 1120px;
`;

export const SecTitle = styled.section`
  display:flex;
  margin: 15px auto 40px;
  padding: 0 30px;
  height: 28px;
  font-size: 16px;
  color: ${BLACK};
  justify-content: left;
  align-items: center;
  div {
    font-size:22px;
    font-family: ${FONT_FAMILY};
    margin-right: 10px;
  }
  span {
    margin-left: 16px;
    cursor:pointer;
  }
  section {
    position:relative;
    top: -3px;
    margin-left: 16px;
    cursor:pointer;
    width: 18px;
    height: 18px;
    text-decoration: none;
  }
  span {
    font-family: ${FONT_FAMILY};
    font-size: 12px;
	  text-decoration: underline;
	  color: "${BLACK}";
  }
`;

export const RefineProductsPart = styled.section`
  margin: 0;
`;

export const MinusPlusIcon = styled.img`
  width: 18px;
  height: 18px;
`;

export const ClearButton = styled.span`
  margin: 0;
`;

export const SearchButtonWrapper = styled.div`
  width: 100%;
  font-size: 14px;
  display: block;
  padding: 0px 10px;
  border-left: 1px solid rgb(213, 213, 213);

  &:last-of-type {
    border-right: 1px solid rgb(213, 213, 213);
  }

  ${media.tabletP`
    display: flex;
    justify-content: center;
  `};
`;

export const SearchButton = styled.div`
  cursor: pointer;
  text-align: center;

  ${media.tabletP`
    padding: 0px 20px 0 10px;
  `};
`;

export const SearchButtonText = styled.span`
  text-decoration: ${({ textDecoration }) => textDecoration};
`;

export const MagnifyingGlassIconWrapper = styled.div`
  margin: 0;
`;

export const SpinnerForSp = styled.div`
  position: relative;
  margin-left: 20px;
  height: 28px;
  .spinnerForSp {
    position: absolute;
    left: 0;
    top: 3px;
  }
  ${media.tabletL`
    display: none;
  `};
`;

export const Textsmall = styled.div`
  font-size: 12px;
  font-family: ${FONT_FAMILY};
  margin-top: 15px;
  margin-bottom: 20px;
  padding: 0 30px;
  span {
    color: #7c7c7c;
  }
  &::before,
  &::after {
    clear: both;
    content: '';
    display: block;
    font-size: 0;
    height: 0;
    line-height: 0;
    visibility: hidden;
  }
`;
export const Hr = styled.div`
    background: #d5d5d5;
    height:1px;
    margin: 40px 30px;
    }
     ${media.tabletL`
     margin: 10px 60px;
    `}
    ${media.tabletP`
    margin: 40px 30px;
    `}
`;

export const OneContent = styled.section`
  padding: 0 20px;
  margin-top: -13px;
  max-height: ${({ isShowLines }) => (isShowLines ? '100%' : 0)};
  opacity: ${({ isShowLines }) => (isShowLines ? 1 : 0)};
  display: flex;
  flex-flow: row wrap;
  > div {
    position: relative;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% / 2);
    // padding: 0 10px;
    ${media.tabletP`
      flex-basis: calc(99% / 3);
    `}${media.tabletL`
      flex-basis: calc(100% / 5);
    `}
    > li {
      margin-top: 30px;
      margin-left: 10px;
      margin-right: 10px;
      list-style-type: none;
      // width: 100%;
      height: 62px;
      line-height: 25px;
      font-size: 14px;
      text-transform: uppercase;
      text-align: center;
      border: 1px solid #ccc;
      color: #ccc;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      box-sizing: border-box;
      ${media.tabletL`
        margin-top: 50px;
      `} 
      span {
        display: block;
        height: 25px;
        line-height: 1;
        padding-top: 2px;
      }
    }
    h5 {
      position: absolute;
      top: 10px;
      left: 10px;
      font-size: 15px;
      font-family: ${FONT_FAMILY};
      ${media.tabletL`
        top: 30px;
      `} 
    }
    div:last-child {
      margin-bottom: 30px;
    }
  }
  section {
    font-size: 12px;
    font-family: ${FONT_FAMILY};
    margin-top: 20px;
    margin-bottom: 0px;
  }
`;

export const LinesAttention = styled.section`
  font-size: 12px;
  font-family: ${FONT_FAMILY};
  margin-top: 20px;
  margin-bottom: 0px;
  padding: 0 30px;
`;

export const TwoContentTab = styled.section`
  padding: 0 30px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 40px;
  ${media.tabletL`
    padding: 0 60px;
  `}${media.tabletP`
    padding: 0 30px;
  `}
  section {
    flex: 1;
    text-align: center;
    span {
      position: relative;
      padding: 0 10px;
      font-size: 14px;
      display: block;
      border-left: 1px solid #d5d5d5;
      > div {
        position: absolute;
        margin-right: 20px;
      }  
    ${media.tabletL`
        padding: 0 19%;
      `}
    }
    .location{
      ${({ available }) => (available ? '' : `color: ${TEXT_GRAY.COMMON_1}`)}
      cursor: ${({ available }) => (available ? 'pointer' : 'default')}
    }
  }
  section:nth-of-type(2){
    >span{
      >div{
        ${media.tabletP`
        margin-left: -25px;
        `}
        ${media.tabletL`
        margin-left: 0;
      `}
      @media screen and (min-width:321px) and (max-width:750px){
        margin-left: 20px;
        margin-top: -19px;
        }
      }
    }
  }
  section:last-of-type {
    border-right: 1px solid #d5d5d5;
  }
  section:hover {
    cursor:pointer;
    span {
      text-decoration: underline;
    }
  }
  .spinnerForPc {
    display: none;
    ${media.tabletL`
      display: block;
  `}
  }
`;

export const FreeWord = styled.div`
  position: relative;
  padding: 0;
  height: 56px;
  line-height: 56px;
  margin: ${({ searched }) => (searched ? '24px 30px 39px' : '24px 30px 84px')};
  ${media.tabletL`;
  margin: ${({ searched }) => (searched ? '24px 60px 39px' : '24px 60px 84px')};
  `}${media.tabletP`;
  margin: ${({ searched }) => (searched ? '24px 30px 39px' : '24px 30px 84px')};
  `};
  border: 1px solid #d2d2d2;
  display: flex;
  flex-direction: row;
  align-items: center;
  input {
    width: calc(100% - 40px);
    height: 50px;
    line-height: 50px;
    padding: 0 80px 0 15px;
    border: 0;
    color: ${BLACK};
    outline: 0;
  }
  > div:focus{
    background: #333;
  }

  > div {
    position: absolute;
    text-align: center;
    outline: 0;
    right: 0;
    top: 0;
    width: 100px;
    height: 54px;
    line-height: 54px;
    background: ${BLACK};
    span {
      font-size: 14px;
      color: #FFF;
    }
    > img {
      margin-top: -5px;
      height: 12px;
      width: 12px;
    }
  }
  div:hover{
    cursor:pointer;
  }
`;

export const SelectWrap = styled.section`
  margin: 30px auto 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 0 20px 0 30px;
  @media screen and (min-width: 321px) and (max-width: 750px) {
    flex-direction: column;
  }
  @media screen and (min-width: 751px) {
    flex-direction: row;
  }
`;

export const SelectBase = styled(Select)`
  width: 49%;
  .ant-select-selection {
    height: 85px;
    line-height: 85px;
    color: #ffffff;
    font-size: 14px;
    font-family: 'Hiragino UD Sans Std';
    padding: 13px 0 13px 29px;
    border: 0;
    border-radius: 0;
    .ant-select-selection__rendered {
      line-height: 62px;
    }
    .ant-select-arrow .ant-select-arrow-icon svg {
      color: white;
    }
  }
  .ant-select-dropdown {
    width: 525px;
  }
  @media screen and (min-width: 321px) and (max-width: 750px) {
    width: 98%;
  }
  @media screen and (min-width: 751px) {
    width: 49%;
  }
`;
export const SelectOne = SelectBase.extend`
  .ant-select-selection {
    background: ${BLACK};
    color: #ffffff;
  }
  [aria-expanded='true'] {
    background: #ffffff;
    color: ${BLACK};
    .ant-select-arrow .ant-select-arrow-icon svg {
      color: ${BLACK};
    }
    box-shadow: 0px 0px 5px 0px rgba(52, 52, 52, 0.3);
  }
`;
export const SelectTwo = SelectBase.extend`
  .ant-select-selection {
    background: ${({ isOneSelect }) => (isOneSelect ? '#000' : '#7c7c7c !important')};
  }
  .ant-select-disabled {
    background: #7c7c7c !important;
    cursor: not-allowed;
  }
  [aria-expanded='true'] {
    background: #ffffff !important;
    color: ${BLACK};
    .ant-select-arrow .ant-select-arrow-icon svg {
      color: ${BLACK};
    }
    box-shadow: 0px 0px 5px 0px rgba(52, 52, 52, 0.3);
  }
  @media screen and (min-width: 321px) and (max-width: 750px) {
    margin-top: 30px !important;
    width: 98%;
  }
`;

export const Option = styled.option``;

export const Spacer = styled.div`
  height: 40px;
`;



// WEBPACK FOOTER //
// ./src/pages/SalonLocator/WithLines/WithLines.style.js